import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "src/app/guard/guard.component";
import { PageNotFoundComponent } from "src/app/share-modul/components/page-not-found/page-not-found.component";
import { VenuesComponent } from "../../resy-modul/components/venues/venues.component";
import { ReservationsComponent } from "../../resy-modul/components/reservations/reservations.component";


const routes: Routes = [
    { path: 'venues', component: VenuesComponent, canActivate: [AuthGuard] },
    { path: 'venues', component: VenuesComponent, canActivate: [AuthGuard] },
    { path: 'venues/:id/reservations', component: ReservationsComponent, canActivate: [AuthGuard] },
    { path: 'page-not-found', component: PageNotFoundComponent, canActivate: [AuthGuard] },
    { path: '**', redirectTo: '/page-not-found' }
];
@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})

export class ResyRoutingModule { }
